import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { useFormField } from '@/components/ui/form'

type InstallationFormMessageProps = {
  className?: string
}

export function InstallationFormMessage({ className }: InstallationFormMessageProps) {
  const { t } = useTranslation('installations')
  const { error, formMessageId } = useFormField()
  if (!error?.message) {
    return null
  }
  const messageKey = error.message
  const body = t(messageKey)
  return (
    <p
      data-slot="form-message"
      id={formMessageId}
      className={cn('text-sm text-destructive', className)}
    >
      {body}
    </p>
  )
}
